export default __webpack_public_path__ + "static/media/Perk_2.9463a08b.png";